import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="Powered by 本初会务 ｜ 2014-2026 本初团队"
      links={[]}
    />
  );
};

export default Footer;
